import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { NgxExcelViewerComponent } from './ngx-excel-viewer.component';



@NgModule({
  declarations: [
    NgxExcelViewerComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    NgxExcelViewerComponent
  ]
})
export class NgxExcelViewerModule { }
